<template>
  <div class="d-flex">
    <component
      v-for="(chip, idx) in chips"
      :key="idx"
      :is="chip.component"
      :chip="chip"
      :class="{
        'ml-1': idx !== 0,
        'mr-1': idx !== chips.length - 1,
      }"
    />
  </div>
</template>

<script>
import ChipItem from './ChipItem';
import ChipMenu from './ChipMenu';

export default {
  components: {
    ChipItem,
    ChipMenu,
  },
  props: {
    chips: Array,
  },
};
</script>
